import React from "react";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import PlusCardButton from "../../../PlusCardButton/PlusCardButton";

interface Props {
  onClick: () => void;
}

const AddAnotherPertinentDiagnosisButton = ({ onClick }: Props) => {
  return (
    <PlusCardButton
      style={{ marginTop: 16 }}
      value={translate(STRINGS.ADD_ANOTHER_PERTINENT_DIAGNOSIS)}
      onClick={onClick}
    />
  );
};

export default React.memo(AddAnotherPertinentDiagnosisButton);
